import { useEffect, useState } from 'react'

/**
 * Прокручена ли страница дальше порога. Нужен шапке: в покое она прозрачная и
 * сливается с экраном, а как только содержимое уезжает под неё — проявляется
 * стеклом, чтобы текст не наезжал на текст.
 *
 * @param threshold после скольких пикселей считаем, что прокрутили
 */
export function useScrolled(threshold = 8): boolean {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const update = () => {
      setScrolled(window.scrollY > threshold)
    }

    update()
    window.addEventListener('scroll', update, { passive: true })
    return () => {
      window.removeEventListener('scroll', update)
    }
  }, [threshold])

  return scrolled
}
